import type { CompatibleLanguage } from '@seek/ca-myprofile-utils';

const defaultSiteDescription =
  'Manage your SEEK account settings, including password, email and notification settings.';

const siteDescriptions: Record<string, string> = {
  'candidate-seek-au-en':
    'Manage your SEEK account settings, including password, email and notification settings.',
  'candidate-seek-nz-en':
    'Manage your SEEK account settings, including password, email and notification settings.',
  'candidate-jobsdb-hk-en':
    'Manage your Jobsdb account settings, including password, email and notification settings.',
  'candidate-jobsdb-th-en':
    'Manage your Jobsdb account settings, including password, email and notification settings.',
  'candidate-jobsdb-th-th':
    'จัดการการตั้งค่าบัญชีผู้ใช้ Jobsdb ของคุณ รวมถึงรหัสผ่าน อีเมล และการแจ้งเตือน',
  'candidate-jobstreet-sg-en':
    'Manage your Jobstreet account settings, including password, email and notification settings.',
  'candidate-jobstreet-id-en':
    'Manage your Jobstreet account settings, including password, email and notification settings.',
  'candidate-jobstreet-id-id':
    'Kelola pengaturan akun Jobstreetmu, termasuk pengaturan kata sandi, email, dan notifikasi.',
  'candidate-jobstreet-ph-en':
    'Manage your Jobstreet account settings, including password, email and notification settings.',
  'candidate-jobstreet-my-en':
    'Manage your Jobstreet account settings, including password, email and notification settings.',
  'candidate-au-en':
    'Manage your SEEK account settings, including password, email and notification settings.',
  'candidate-nz-en':
    'Manage your SEEK account settings, including password, email and notification settings.',
  'candidate-hk-en':
    'Manage your JobsDB account settings, including password, email and notification settings.',
  'candidate-th-en':
    'Manage your JobsDB account settings, including password, email and notification settings.',
  'candidate-th-th':
    'จัดการการตั้งค่าบัญชีผู้ใช้ JobsDB ของคุณ รวมถึงรหัสผ่าน อีเมล และการแจ้งเตือน',
  'candidate-sg-en':
    'Manage your Jobstreet account settings, including password, email and notification settings.',
  'candidate-id-en':
    'Manage your Jobstreet account settings, including password, email and notification settings.',
  'candidate-id-id':
    'Kelola pengaturan akun Jobstreetmu, termasuk pengaturan kata sandi, email, dan notifikasi.',
  'candidate-ph-en':
    'Manage your Jobstreet account settings, including password, email and notification settings.',
  'candidate-my-en':
    'Manage your Jobstreet account settings, including password, email and notification settings.',
};

export default (
  site: string = 'candidate-seek-au',
  language: CompatibleLanguage = 'en',
): string => siteDescriptions[`${site}-${language}`] || defaultSiteDescription;
